import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconArrowUp: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconArrowUp" {...props}>
    <svg height="100%" viewBox="0 0 32 32" fill="currentColor">
      <path d="M.09375 23.5c.03125-.125.125-.25.21875-.3438l14.875-14.87495c.2187-.1875.4687-.28125.75-.28125s.5313.09375.75.28125L31.3438 22.9688c.2187.2187.3124.4687.3124.75 0 .2812-.0937.5312-.3124.75-.2188.2187-.4688.3124-.75.3124-.2813 0-.5313-.0937-.75-.3124L15.9375 10.5625 1.8125 24.6562c-.21875.2188-.46875.3126-.75.3126s-.53125-.0938-.75-.3126c-.09375-.0937-.1875-.1874-.21875-.3437-.0625-.125-.09375-.25-.09375-.4063 0-.125.03125-.25.09375-.4062Z" />
    </svg>
  </IconSVG>
)
